import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { PopupService } from '../../../../services/popup.service';
import { MyStuffService } from '../../../../services/my-stuff.service';
import { PinTypeEnum } from "../../../../enums/PinTypeEnum";
import { states } from "../../../../constants/Global";
import { Observable } from "rxjs";

@Component({
  selector: 'app-removed-items',
  templateUrl: './removed-items.component.html',
  styleUrls: ['./removed-items.component.less']
})
export class RemovedItemsComponent implements OnInit {

  constructor(public popupService: PopupService, public myStuffService: MyStuffService,
    public ref: ChangeDetectorRef) { }

    removedItemsElement: any;

    ngOnInit() {}


    onChangeRemovedItemsOption(event) {
        let selectedIndex = event.target.options.selectedIndex;
        this.myStuffService.selectedRemovedItems = event.target.value;
        this.popupService.updateRoute('my-stuff', event.target.dataset.section, event.target.options[selectedIndex].dataset.inner);
        this.removedItemsElement = document.getElementById('removed');
        this.removedItemsElement.setAttribute('data-inner', this.myStuffService.selectedRemovedItems);
    }

}



// WEBPACK FOOTER //
// ./src/app/components/popups/my-stuff/removed-items/removed-items.component.ts